import { combineReducers } from "redux";

import Auth from "./auth/reducers";
import Layout from "./layout/reducers";
import manageUser from "./manageUser/reducers";
import toggleReducer from "./toggleLiveDemo/reducers";

const rootReducer = combineReducers({
  Auth,
  Layout,
  user: manageUser,
  toggleReducer,
});

export default rootReducer;